import debounce from 'lodash.debounce';

export function scrollEndChangeHandler(element, callback) {
  function measureScroll() {
    const scrolledToEnd = element.offsetHeight + element.scrollTop >= element.scrollHeight;
    callback(scrolledToEnd);
  }

  measureScroll();
  element.addEventListener('scroll', debounce(measureScroll, 100), { passive: true });
  window.addEventListener('resize', debounce(measureScroll, 250), { passive: true });
}
